<div class="container-fluid pr-0 pl-0 h-100">
  <div class="row h-100">

    <div class="col-3 mt-1 h-100">
      <div class="row h-100 overflow-auto">

        <div class="col-12 mb-2">
          <div class="d-flex">

            <div class="flex-grow-1 pr-2">
              <div class="position-relative">
                <fa-icon *ngIf="bUserSearchLoader" [icon]="['fas','spinner']" [spin]="true" class="position-absolute search-spinner"></fa-icon>
                <input type="text" class="form-control" placeholder="{{ 'search_'+ strSubcontractor | translate }}" [formControl]="objSearchUser"/>
              </div>
            </div>

            <div *ngIf="bPaginationReady" class="btn-group float-right" role="group">
              <button type="button" (click)="movePage('prev')" class="btn btn-primary p-2" [disabled]="!list.hasPrevPage"><fa-icon [icon]="['far', 'chevron-left']">123</fa-icon></button>
              <button type="button" (click)="movePage('next')"class="btn btn-primary p-2" [disabled]="!list.hasNextPage"><fa-icon [icon]="['far', 'chevron-right']"></fa-icon></button>
            </div>

          </div>
        </div>

        <div class="col-6 mb-2 pr-1">
          <div class="d-flex">
            <ng-select
              [clearable]="false"
              appendTo="body"
              style="width: 100%;"
              [items]="['users', 'subcontractors']"
              [(ngModel)]="strSubcontractor"
              (ngModelChange)="onSubcontractorToggle()">

              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                {{ item | translate }}
              </ng-template>

              <ng-template  ng-option-tmp let-item="item">
                {{ item | translate }}
              </ng-template>

            </ng-select>
          </div>
        </div>

        <div class="col-6 mb-2 pl-1">
          <ng-select
            [items]="objSkillRelate.source | async"
            [loading]="objSkillRelate.loader"
            [typeahead]="objSkillRelate.typehead"
            [(ngModel)]="objSkillRelate.value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onChangeSkill()"
            placeholder="{{ 'search_skill' | translate }}"
            bindLabel="text"
            (open)="!objSkillRelate.value ? objSkillRelate.loadDataOnClick() : null"
            groupBy="module"
            [multiple]="true"
            [clearable]="true"
            class="lh-24"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">
                <span matTooltip="{{ item.text }}">{{ item.text | truncate: 5 }}</span>
              </span>
              <span class="ng-value-icon border-0 right selected-close" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.module | translate }}
            </ng-template>
          </ng-select>
        </div>

        <div class="col-12" style="overflow-x: auto; height: 85%;">
          <ul class="list-group">
            <li *ngIf="arUsers.length == 0" class="list-group-item p-2">{{ 'no_results' | translate }}</li>
            <ng-container *ngFor="let user of arUsers" >
              <li *ngIf="user.status == 'inactive'" class="list-group-item p-2">
                <small class="text-secondary">{{ user.text }} ({{ 'inactive' | translate }})</small>
              </li>
              <li *ngIf="user.status == 'active'" class="list-group-item p-2 newline" [ngClass]="{'active-user': objSelectUser && objSelectUser.id == user.id}" (click)="selectUser(user);" >

                {{ user.display }}

                <span class="float-right">
                  <ng-container *ngIf="user.has_availability">
                    <fa-icon *ngIf="!user.show_availablity" [icon]="['far', 'caret-circle-down']" class="mr-1 pointer text-primary" (click)="user.show_availablity = !user.show_availablity; $event.stopPropagation()"></fa-icon>
                    <fa-icon *ngIf="user.show_availablity" [icon]="['far', 'caret-circle-up']" class="mr-1 pointer text-primary" (click)="user.show_availablity = !user.show_availablity; $event.stopPropagation()"></fa-icon>
                  </ng-container>
                  <fa-icon [icon]="['far', 'calendar']" class="mr-1 pointer text-primary"></fa-icon>
                </span>

                <div class="row w-100">
                  <div class="col-md-12">
                    <ng-container *ngFor="let schedule of user.availability | keyvalue : ignoreSort">
                      <small class="mr-1">
                        <span class="text-secondary">{{ 'days_label.initial.' + schedule.key | translate}}:</span>
                        <span class="text-success">{{ schedule.value.duration }}</span>
                      </small>
                    </ng-container>
                  </div>
                </div>

                <div *ngIf="user.show_availablity" class="row">
                  <ng-container *ngFor="let schedule of user.availability | keyvalue : ignoreSort">
                    <div *ngIf="schedule.value['start_time'] && schedule.value['start_time']" class="col-4">
                      <small class="text-secondary">{{ 'days_label.short.' + schedule.key | translate}}</small> <br>
                      <span class="font-size-11">{{ schedule.value['display_start'] }}</span> <br>
                      <span class="font-size-11">{{ schedule.value['display_end'] }}</span>
                    </div>
                  </ng-container>
                </div>

              </li>
            </ng-container>

          </ul>
        </div>

      </div>
    </div>

    <div class="col-9 h-100 overflow-auto">
      <div class="row h-100">

        <div *ngIf="objSelectUser" class="col-12 mt-1 pl-0">
          <div class="row">
            <div class="col-6">
              <h5 >{{ 'set_scheduled_pre' | translate }} {{ objSelectUser.text }}</h5>
            </div>
            <div class="col-6 d-flex justify-content-end d-flex-gap align-items-center">
              <ng-container *ngIf="!objSelectUser.is_subcontractor">
                <span
                  *ngIf="notifyPush.notifyViaPush"
                  class="btn btn-link"
                  (click)="notifyPush.onEditNotificationMessage()">
                  {{ 'edit' | translate }}
                </span>
                <fieldmagic-checkbox-input
                  [(ngModel)]="notifyPush.notifyViaPush"
                >
                  <span class="pr-3">
                    {{ 'notify' | translate }}
                    <fa-icon
                      [icon]="['fas', 'info-circle']"
                      class="pointer fs-12"
                      matTooltip="{{ 'notify_tip' | translate }}">
                    </fa-icon>
                  </span>
                </fieldmagic-checkbox-input>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="col-12 pt-2 pl-0" style="overflow-x: auto; height: 100%;">
          <div *ngIf="!objSelectUser" class="overlay-note">
            <h5>{{ 'schedule_user_tip' | translate }}</h5>
          </div>
          <input class="go-to-date-input" [owlDateTimeTrigger]="dateInput" [owlDateTime]="dateInput" (dateTimeChange)="_onGoToDateChange($event)"/>
          <owl-date-time #dateInput [pickerType]="'calendar'"></owl-date-time>
          <full-calendar #fullcalendar [options]="options" [ngStyle]="{'opacity': objSelectUser == null ? 0 : 1}" class="task-calendar-style"></full-calendar>
        </div>

      </div>
    </div>

  </div>
</div>

<context-menu #eventContextMenu>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('copy', $event.item.origin, $event.item.event)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': item.origin == 'date' }">{{ 'calendar_contextmenu_copy' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('cut', $event.item.origin, $event.item.event)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': item.origin == 'date' }">{{ 'calendar_contextmenu_cut' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('paste', $event.item.origin, $event.item.event)">
    <div class="fs-14  col-12" [ngClass]="{'d-none': item.origin == 'event' }">{{ 'calendar_contextmenu_paste' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item>
    <hr class="mt-2 mb-2" [ngClass]="{'d-none': !item.job && !item.opportunity && !item.site && !item.customer }"/>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('edit_job', $event.item.origin, $event.item.job)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.job }">{{ 'edit_job' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('edit_opportunities', $event.item.origin, $event.item.opportunity)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.opportunity }">{{ 'edit_quote' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('edit_site', $event.item.origin, $event.item.site)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.site }">{{ 'edit_site' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('edit_customer', $event.item.origin, $event.item.customer)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.customer }">{{ 'edit_customer' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item>
    <hr class="mt-2 mb-2" [ngClass]="{'d-none': !item.show_job && !item.show_quote }"/>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('show_job', $event.item.origin, $event.item.event_metadata)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.show_job }">{{ 'show_job' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('show_quote', $event.item.origin, $event.item.event_metadata)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': !item.show_quote }">{{ 'show_quote' | translate }}</div>
  </ng-template>
  <ng-template contextMenuItem let-item>
    <hr class="mt-2 mb-2" [ngClass]="{'d-none': item.origin == 'date' }"/>
  </ng-template>
  <ng-template contextMenuItem let-item (execute)="contextMenuTrigger('add_notes', $event.item.origin, $event.item.extendedProps)">
    <div class="fs-14 col-12" [ngClass]="{'d-none': item.origin == 'date' }">{{ 'note' | translate }}</div>
  </ng-template>
</context-menu>